(() => {
  const configNode = document.getElementById('nlt-cut-config');
  const dialog = document.getElementById('nlt-cut-dialog');
  if (!configNode || !dialog || window.nltCuttingInstalled) return;
  window.nltCuttingInstalled = true;
  const config = JSON.parse(configNode.textContent);
  const t = config.text;
  const root = window.Shopify?.routes?.root || '/';
  const ids = new Set(Object.values(config.variants).map(Number));
  const el = id => document.getElementById('nlt-cut-' + id);
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'es-MX', {style:'currency',currency:window.Shopify?.currency?.active || 'MXN'}).format(cents / 100);
  let selection = null;
  let busy = false;
  let opener = null;
  const request = async (path, payload) => {
    const response = await fetch(root + path, payload ? {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)} : {headers:{'Accept':'application/json'},cache:'no-store'});
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : t.error);
    return result;
  };
  const remaining = (cart, parent) => Math.max(0, parent.quantity - cart.items.filter(i => ids.has(i.variant_id) && i.parent_relationship?.parent_key === parent.key).reduce((n,i) => n+i.quantity,0));
  const quoteLink = () => {
    if (!selection) return;
    const lines = [t.quote_intro,selection.title,selection.sku,location.origin + root + 'products/' + selection.handle];
    if (el('unknown').checked) lines.push(t.no_code);
    if (el('original').checked) lines.push(t.has_original);
    el('whatsapp').href = 'https://wa.me/526251951223?text=' + encodeURIComponent(lines.filter(Boolean).join('\n'));
  };
  const update = () => {
    if (!selection) return;
    const quote = !selection.variant || el('unknown').checked;
    el('submit').hidden = quote;
    el('whatsapp').hidden = !quote;
    el('quote-help').hidden = !quote;
    el('original-wrap').hidden = !el('unknown').checked;
    el('quantity-wrap').hidden = quote;
    el('quantity').disabled = quote;
    el('code').disabled = el('unknown').checked;
    el('code').required = !quote;
    el('total').textContent = selection.variant ? t.total + ': ' + money(selection.variant.price * Number(el('quantity').value || 1)) : '';
    quoteLink();
  };
  const close = () => {
    if (busy) return;
    dialog.close();
    if (opener?.isConnected) opener.focus();
  };
  const open = async button => {
    if (busy || dialog.open) return;
    opener = button;
    button.disabled = true;
    try {
      const cart = await request('cart.js');
      const parent = cart.items.find(i => i.key === button.dataset.nltCutKey);
      if (!parent) throw new Error(t.missing);
      selection = {key:parent.key,title:parent.product_title,sku:parent.sku,handle:parent.handle,type:button.dataset.nltCutType,variant:null};
      el('form').reset();
      el('status').textContent = '';
      el('product').textContent = parent.product_title;
      el('price').textContent = t.special;
      if (selection.type) {
        try {
          const product = await request('products/' + config.serviceHandle + '.js');
          selection.variant = product.variants.find(v => v.id === config.variants[selection.type] && v.available) || null;
        } catch (_) { selection.variant = null; }
        el('price').textContent = t[selection.type] + ' · ' + money(selection.variant?.price ?? config.prices[selection.type]) + ' / ' + t.unit;
        if (!selection.variant) el('status').textContent = t.unavailable;
      }
      const available = remaining(cart,parent);
      el('quantity').max = available;
      el('quantity').value = 1;
      el('submit').disabled = available === 0;
      if (!available) el('status').textContent = t.limit;
      update();
      document.querySelector('cart-drawer.active')?.close();
      dialog.showModal();
      el('code').focus();
    } catch (error) {
      let note = button.parentElement.querySelector('[role="status"]');
      if (!note) { note = document.createElement('p'); note.setAttribute('role','status');button.parentElement.append(note); }
      note.textContent = error.message || t.error;
    } finally { button.disabled = false; }
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-nlt-cut-key]');
    if (trigger) { event.preventDefault(); open(trigger); }
    if (event.target.closest('[data-cut-close]')) close();
  });
  dialog.addEventListener('cancel',event=>{if(busy)event.preventDefault();});
  ['unknown','original','quantity','code'].forEach(id=>el(id).addEventListener('input',update));
  el('code').addEventListener('input',()=>el('code').setCustomValidity(''));
  el('form').addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !selection?.variant || el('unknown').checked) return;
    const code = el('code').value.trim().toUpperCase();
    if (!/^[A-Z0-9][A-Z0-9 -]{0,39}$/.test(code)) {
      el('code').setCustomValidity(t.code_required);el('code').reportValidity();return;
    }
    const quantity = Number(el('quantity').value);
    if (!Number.isInteger(quantity) || quantity < 1) return;
    busy = true;
    el('submit').disabled = true;
    el('submit').textContent = t.busy;
    el('status').textContent = '';
    try {
      const cart = await request('cart.js');
      const parent = cart.items.find(i=>i.key === selection.key);
      if (!parent) throw new Error(t.missing);
      const available = remaining(cart,parent);
      if (quantity > available) {el('quantity').max=available;throw new Error(t.changed);}
      await request('cart/add.js',{items:[{id:selection.variant.id,quantity,parent_line_key:parent.key,properties:{'Llave':parent.product_title,'SKU de la llave':parent.sku || String(parent.variant_id),'Código de corte':code,'Tipo de corte':t[selection.type],'_nlt_cut_service':'1','_nlt_cut_parent':parent.key,'_nlt_cut_id':crypto.randomUUID()}}]});
      location.assign(root + 'cart');
    } catch (error) {
      el('status').textContent = error.message || t.error;
      busy=false;el('submit').disabled=false;el('submit').textContent=t.add;
    }
  });
  let reconcileBusy = false;
  const reconcile = async () => {
    if (reconcileBusy || busy) return;
    reconcileBusy = true;
    try {
      let cart = await request('cart.js');
      const used = new Map();
      let changed = false;
      for (const item of [...cart.items]) {
        if (!ids.has(item.variant_id) || item.properties?._nlt_cut_service !== '1') continue;
        const key = item.parent_relationship?.parent_key;
        const parent = cart.items.find(i=>i.key===key);
        const allowed = Math.max(0,(parent?.quantity || 0)-(used.get(key)||0));
        const target = Math.min(item.quantity,allowed);
        used.set(key,(used.get(key)||0)+target);
        if (target !== item.quantity) {
          cart = await request('cart/change.js',{id:item.key,quantity:target});changed=true;
        }
      }
      if (changed) location.reload();
    } catch (error) {
      document.dispatchEvent(new CustomEvent('nlt:cutting-error',{detail:{message:error.message}}));
    } finally { reconcileBusy=false; }
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate,event=>{if(event.source === 'cart-items') reconcile();});
  }
  if (document.querySelector('[data-nlt-cut-service]')) reconcile();
})();
